import axios from 'axios';
import toCamelCase from '../utils/camelCase';
import getExpConfig from '../utils/getExpConfig';
import {
  API_ENDPOINT_SKUMAPPER,
  API_ENDPOINT_SKU_PRICING,
  recordStormDoorApiFailure,
  recordStormDoorApiSuccess,
  APP_ACTION_SKU_MAP_CALL,
  CONTEXT_SKU_MAP_NO_RESULT,
  recordStormDoorAction,
  recordApiResponse,
  API_ENDPOINT_CHOICE_SKU_AVAILABILITY,
  API_ENDPOINT_LINE_ITEM_PRICING,
} from '../utils/newRelic';

const logApiSuccess = (apiEndpoint) => (response) => {
  recordStormDoorApiSuccess(apiEndpoint, response.status);
  return response;
};

export const mapChoicesToSkus = (siteId, productId, storeId, choices) => {
  const endpoint = API_ENDPOINT_SKUMAPPER;
  const url = `${getExpConfig('sku-mapping-api-base-url')}/api/MapChoicesToSkusWithMultipliers`;

  const json = {
    siteId,
    productId,
    storeId,
    choices,
  };

  return axios
    .post(url, json)
    .then(logApiSuccess(endpoint))
    .then((response) => response.data)
    .then(toCamelCase)
    .catch((error) => {
      if (error.response.data.sku === null) {
        recordStormDoorAction(
          APP_ACTION_SKU_MAP_CALL,
          'No SKU was returned when trying to get mapped Skus',
          CONTEXT_SKU_MAP_NO_RESULT
        );
      } else {
        recordStormDoorApiFailure(endpoint, error.response.status || 500, url, json);
      }
      throw error;
    });
};

export const getSkuPricing = (sku, skuType, productId) => {
  const url = `${getExpConfig('sku-pricing-api-url')}/pricing/GetRetailPrice`;
  const params = { sku, skuType, productId };

  const promise = axios.get(url, { params });

  return recordApiResponse(promise, API_ENDPOINT_SKU_PRICING, url, params).then(
    (response) => response.data
  );
};

export const mapChoiceSkuAvailability = (productId, storeId) => {
  const url = `${getExpConfig(
    'sku-mapping-api-base-url'
  )}/api/CheckProductChoiceAndSkuAvailability`;
  const params = { productId, storeId };
  const promise = axios.get(url, { params });
  return recordApiResponse(promise, API_ENDPOINT_CHOICE_SKU_AVAILABILITY, url, params).then(
    (response) => response.data
  );
};

export const customLineItemPricing = (...args) => {
  const url = `${getExpConfig('base-api-url')}/skupricing-api/pricing/GetPPEPrices`;

  const params = Array.isArray(args[0]) ? args[0] : args;
  const promise = axios({
    data: params[0],
    url,
    method: 'POST',
    crossDomain: true,
  });
  return recordApiResponse(promise, API_ENDPOINT_LINE_ITEM_PRICING, url, params).then((response) => {
    return response.data ? response.data.selectedChoicePrices : null
  });
};
